var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AsiAutocomplete',{attrs:{"items":_vm.countries,"label":_vm.finalLabel,"rules":_vm.rules,"value":_vm.value,"autocomplete":"chrome-off","clearable":_vm.clearable,"multiple":_vm.multiple},on:{"change":_vm.change,"input":_vm.input}})}
var staticRenderFns = []

export { render, staticRenderFns }